<template>
  <validation-provider
    v-slot="{ valid, changed, dirty, errors, validate }"
    :rules="rules"
    :vid="vid"
    ref="provider"
    :name="label"
    :detect-input="detectInput"
    :immediate="immediate"
  >
    <b-form-group v-bind="$attrs" :state="changed || dirty ? valid : null">
      <template slot="label">
        <span>
          {{ label }}
        </span>
        <fa-icon v-if="description" v-b-tooltip.hover.right="{ variant: 'light', title: description }" :icon="['far', 'question-circle']" class="text-gray"/>
      </template>
      <slot v-bind:state="changed || dirty ? valid : null" v-bind:validate="validate">
        <slot />
      </slot>
      <template v-if="!hideFeedback" slot="invalid-feedback">
        <fa-icon :icon="['fa', 'exclamation-circle']"/>
        {{ errors[0] | capitalize }}
      </template>
      <template v-if="!hideFeedback" slot="valid-feedback">
        <fa-icon :icon="['fa', 'check-circle']"/>
      </template>
    </b-form-group>
  </validation-provider>
</template>

<script>

import { ValidationProvider } from "vee-validate"


export default {
  name: "DistributionFormGroup",
  components: { ValidationProvider },
  props: {
    description: String,
    label: String,
    rules: String,
    vid: {
      type: String,
      required: true,
    },
    detectInput: {
      type: Boolean,
      default: true,
    },
    immediate: {
      type: Boolean,
      default: true,
    },
    hideFeedback: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    setErrors (errors) {
      this.$refs.provider.setErrors(errors)
      this.$refs.provider.setFlags({ dirty: true })
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep legend:has(+ div :is(input,select,div.multiselect)[required]) span::after {
    content: "*";
    color: $red;
    margin-left: 3px;
    margin-right: 3px;
  }

  ::v-deep .form-row > .col {
    display: flex;

    &>:is(input,select,div.multiselect,div.input-group,textarea) {
      max-width: 70%;
    }
    &>:is(input,div.input-group,textarea) {
      background-image: none;
    }


  }
  ::v-deep .invalid-feedback, ::v-deep .valid-feedback {
    padding-left: 10px;
    margin-left: 0;
    margin-top: 8px;
    max-width: 25%;
    font-size: 14px !important;
  }

  ::v-deep  div[role=radiogroup] ~ .valid-feedback {
    display: none !important;
  }

  ::v-deep .mx-datepicker {
    width: 100%;
    max-width: 70%;
    display: block;
    position: initial;
    &.invalid { .mx-input { border-color: $red; } }
  }

</style>
